<template>
  <div>
    <b-container fluid class="content leftmenu">
      <b-alert
        :show="countdown"
        dismissible
        variant="success"
        @dismissed="countdown = 0"
        @dismiss-count-down="close_alert"
        class="show_alert"
      >
        {{ dismessage }}
      </b-alert>
      <b-row>
        <b-col>
          <b-card v-if="cur_left_menu">
            <el-table
              ref="multipleTable"
              stripe
              class="table-responsive table"
              header-row-class-name="thead-light"
              :data="cur_left_menu"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column label="Name">
                <template slot-scope="scope">
                  <div v-if="scope.row.id % 100">
                    {{ scope.row.Name1 }} - {{ scope.row.Name2 }}
                  </div>
                  <div v-else>{{ scope.row.Name1 }}</div>
                </template>
              </el-table-column>
            </el-table>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col> </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { Table, TableColumn, Button, Row, Col } from "element-ui";
// import InputAutocomplete from "../InputAutocomplete";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { getStore, setStore } from "../../util/helper";

const axios = require("axios");

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    // InputAutocomplete,
  },
  data() {
    return {
      multipleSelection: [],
      new_left_menu: [
        { id: 100, Status: 0, Name1: "Store", Name2: "Store" },
        { id: 101, Status: 0, Name1: "Store", Name2: "Store" },
        { id: 102, Status: 0, Name1: "Store", Name2: "Table" },
        { id: 103, Status: 0, Name1: "Store", Name2: "Menu" },
        { id: 104, Status: 0, Name1: "Store", Name2: "Soldout" },
        { id: 200, Status: 0, Name1: "Setup", Name2: "Setup" },
        { id: 201, Status: 0, Name1: "Setup", Name2: "Tax" },
        { id: 202, Status: 0, Name1: "Setup", Name2: "POS Setting" },
        { id: 203, Status: 0, Name1: "Setup", Name2: "Printer" },
        { id: 204, Status: 0, Name1: "Setup", Name2: "Payment Setting" },
        { id: 205, Status: 0, Name1: "Setup", Name2: "Staff" },
        { id: 206, Status: 0, Name1: "Setup", Name2: "Import / Export" },
        { id: 207, Status: 0, Name1: "Setup", Name2: "Happy Hour" },
        { id: 208, Status: 0, Name1: "Setup", Name2: "Delivery" },
        { id: 209, Status: 0, Name1: "Setup", Name2: "Quick Notes" },
        { id: 209, Status: 0, Name1: "Setup", Name2: "Cloud Store" },
        { id: 300, Status: 0, Name1: "Product", Name2: "Product" },
        { id: 301, Status: 0, Name1: "Product", Name2: "Department" },
        { id: 302, Status: 0, Name1: "Product", Name2: "Category" },
        { id: 303, Status: 0, Name1: "Product", Name2: "Modifier" },
        { id: 304, Status: 0, Name1: "Product", Name2: "Product" },
        { id: 305, Status: 0, Name1: "Product", Name2: "BOM" },
        { id: 400, Status: 0, Name1: "VIP", Name2: "VIP" },
        { id: 401, Status: 0, Name1: "VIP", Name2: "VIP" },
        { id: 402, Status: 0, Name1: "VIP", Name2: "VIP Setting" },
        { id: 500, Status: 0, Name1: "Sale", Name2: "Sale" },
        { id: 501, Status: 0, Name1: "Sale", Name2: "Customer" },
        { id: 502, Status: 0, Name1: "Sale", Name2: "SO" },
        { id: 600, Status: 0, Name1: "Purchase", Name2: "Purchase" },
        { id: 601, Status: 0, Name1: "Purchase", Name2: "Vendor" },
        { id: 602, Status: 0, Name1: "Purchase", Name2: "PO" },
        { id: 700, Status: 0, Name1: "Inventory", Name2: "Inventory" },
        { id: 701, Status: 0, Name1: "Inventory", Name2: "Inventory" },
        { id: 702, Status: 0, Name1: "Inventory", Name2: "Receiving" },
        { id: 703, Status: 0, Name1: "Inventory", Name2: "Shipping" },
        { id: 704, Status: 0, Name1: "Inventory", Name2: "Inbound" },
        { id: 705, Status: 0, Name1: "Inventory", Name2: "Outbound" },
        { id: 706, Status: 0, Name1: "Inventory", Name2: "Stock Take" },
        { id: 707, Status: 0, Name1: "Inventory", Name2: "Management" },
        { id: 708, Status: 0, Name1: "Inventory", Name2: "Transfer" },
        { id: 800, Status: 0, Name1: "Report", Name2: "Report" },
        { id: 801, Status: 0, Name1: "Report", Name2: "Day End Report" },
        { id: 802, Status: 0, Name1: "Report", Name2: "Attendance Report" },
        { id: 803, Status: 0, Name1: "Report", Name2: "Sales By Category" },
        { id: 804, Status: 0, Name1: "Report", Name2: "Sales By Product" },
        { id: 805, Status: 0, Name1: "Report", Name2: "VIP Sales" },
        { id: 806, Status: 0, Name1: "Report", Name2: "VIP Reload" },
        { id: 807, Status: 0, Name1: "Report", Name2: "POS Sales Report By Category" },
        { id: 808, Status: 0, Name1: "Report", Name2: "POS Transaction" },
        { id: 809, Status: 0, Name1: "Report", Name2: "Transaction Note" },
        { id: 810, Status: 0, Name1: "Report", Name2: "Purchase Summary" },
        { id: 811, Status: 0, Name1: "Report", Name2: "Purchase Item" },
        { id: 812, Status: 0, Name1: "Report", Name2: "Inventory Summary" },
        { id: 813, Status: 0, Name1: "Report", Name2: "Modifier Report" },
        { id: 814, Status: 0, Name1: "Report", Name2: "Hourly Sales" },
        { id: 815, Status: 0, Name1: "Report", Name2: "Tips" },
      ],
      cur_left_menu: null,
      left_menu: null,
      ison: 0,

      delay_timer: null,

      dismessage: "",
      countdown: 0,

      today: "",

      token: "",
      user_id: 0,
    };
  },
  computed: {
    apiBaseUrl: function () {
      return axios.defaults.baseURL + "/Api";
    },
  },
  methods: {
    close_alert(countDownChanged) {
      this.countdown = countDownChanged;
      if (this.countdown == 0) {
        this.dismessage = "";
      }
    },
    set_one_cur_left_menu(id, Status, toggle) {
      for (var i = 0; i < this.cur_left_menu.length; i++) {
        if (this.cur_left_menu[i].id == id) {
          this.cur_left_menu[i].Status = Status;
          if (toggle) {
            this.$refs.multipleTable.toggleRowSelection(
              this.cur_left_menu[i],
              Status
            );
          }
          return;
        }
      }
    },
    set_mul_cur_left_menu(sid, eid, Status, toggle) {
      for (var i = 0; i < this.cur_left_menu.length; i++) {
        if (this.cur_left_menu[i].id > sid) {
          if (this.cur_left_menu[i].id <= eid) {
            this.cur_left_menu[i].Status = Status;
            if (toggle) {
              this.$refs.multipleTable.toggleRowSelection(
                this.cur_left_menu[i],
                Status
              );
            }
          } else {
            return;
          }
        }
      }
    },
    check_cur_left_menu(sid, Status, NStatus) {
      var eid = sid + 99;
      var row = null;
      for (var i = 0; i < this.cur_left_menu.length; i++) {
        if (this.cur_left_menu[i].id == sid) {
          row = this.cur_left_menu[i];
        }
        if (this.cur_left_menu[i].id > sid) {
          if (this.cur_left_menu[i].id <= eid) {
            if (this.cur_left_menu[i].Status != Status) {
              return;
            }
          } else {
            if (row) {
              this.$refs.multipleTable.toggleRowSelection(row, NStatus);
            }
            return;
          }
        }
      }
    },
    get_difference(v1, v2) {
      var diff = [];
      var find;
      for (var i = 0; i < v1.length; i++) {
        find = 0;
        for (var j = 0; j < v2.length; j++) {
          if (v1[i].id == v2[j].id) {
            find = 1;
            break;
          }
        }
        if (!find) {
          diff.push(v1[i]);
        }
      }
      return diff;
    },
    handleSelectionChange(val) {
      var vold = JSON.parse(JSON.stringify(this.multipleSelection));
      var vnew = JSON.parse(JSON.stringify(val));
      this.multipleSelection = val;

      var newlen = vnew.length,
        oldlen = vold.length;

      if (!this.ison) {
        this.ison = 1;

        if (Math.abs(newlen - oldlen) < 2) {
          var diff = this.get_difference(vnew, vold);
          if (diff.length > 0) {
            // Add row
            this.set_one_cur_left_menu(diff[0].id - (diff[0].id % 100), 1, 1);
            if (diff[0].id % 100) {
              this.set_one_cur_left_menu(diff[0].id, 1, 0);
            } else {
              this.set_mul_cur_left_menu(diff[0].id, diff[0].id + 99, 1, 1);
            }
          } else {
            diff = this.get_difference(vold, vnew);
            if (diff.length > 0) {
              // Remove
              this.set_one_cur_left_menu(diff[0].id, 0, 0);
              if (diff[0].id % 100) {
                this.check_cur_left_menu(diff[0].id - (diff[0].id % 100), 0, 0);
              } else {
                this.set_mul_cur_left_menu(diff[0].id, diff[0].id + 99, 0, 1);
              }
            }
          }
        } else {
          var nstat;
          if (newlen) {
            // Add all
            nstat = 1;
          } else {
            // Remove all
            nstat = 0;
          }
          this.cur_left_menu.forEach((row) => {
            row.Status = nstat;
          });
        }
        this.ison = 0;
        this.form_submit_delay();
      }
    },
    add_menu() {
      this.ison = 1;
      this.cur_left_menu = JSON.parse(JSON.stringify(this.new_left_menu));
      if (this.left_menu) {
        for (var i = 0; i < this.left_menu.length; i++) {
          for (var j = 0; j < this.cur_left_menu.length; j++) {
            if (this.cur_left_menu[j].id == this.left_menu[i].id) {
              this.cur_left_menu[j].Status = this.left_menu[i].Status;
              break;
            }
          }
        }
      }
      this.$nextTick(() => {
        for (var i = 0; i < this.cur_left_menu.length; i++) {
          this.$refs.multipleTable.toggleRowSelection(
            this.cur_left_menu[i],
            this.cur_left_menu[i].Status
          );
        }
        this.ison = 0;
      });
    },
    row_clicked_event(row, event, column) {
      // console.log("row_clicked_event", row, event, column);
      event.preventDefault();
      this.show_listed_products = false;

      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("IDn", row.IDn);

      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/Inventory/Inbound/product",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.cur_order = JSON.parse(JSON.stringify(row));
              that.cur_Products = rt.data.products;
              that.$refs["my-modal"].show();
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    form_submit_delay() {
      if (this.delay_timer) {
        clearTimeout(this.delay_timer);
        this.delay_timer = null;
      }
      var that = this;
      this.delay_timer = setTimeout(() => {
        that.form_submit();
      }, 800);
    },
    async form_submit() {
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("LeftMenu", JSON.stringify(this.cur_left_menu));

      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/Left_menu/update",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.dismessage = that.$t("Data Updated Successfully");
              that.countdown = 2;
              that.left_menu = JSON.parse(rt.data.left_menu.Menu);
              that.add_menu();
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    async init_data() {
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/left_menu",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              if (rt.data.left_menu && rt.data.left_menu.Menu) {
                that.left_menu = JSON.parse(rt.data.left_menu.Menu);
              }
              that.add_menu();
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          that.$router.push("/login");
        });
    },
  },
  mounted() {
    this.windowHeight = window.innerHeight;
    this.token = getStore("token");
    this.user_id = getStore("user_id");
    var today = new Date();
    this.today =
      today.getFullYear() +
      "-" +
      String(today.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(today.getDate()).padStart(2, "0");

    if (!this.token || !this.user_id) {
      this.$router.push("/login");
      return;
    }
    return this.init_data();
  },
};
</script>
<style>
.content {
  padding-top: 3rem;
}
.show_alert {
  position: absolute;
  top: 3rem;
  width: 100%;
  z-index: 100;
}
.leftmenu .card .table td {
  padding: 0rem 0.5rem;
}
</style>
